import React, { useEffect, useState, Fragment } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ThirdsApi from '../../Reports/api/thirds_api';
import ModalTemplatePdf from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/ModalTemplatePDF';
import GenerateExcelReportServices from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/GenerateExcelReportServices';
import GeneratePDFReportServices from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/GeneratePDFReportServices';
import DataReactTableSettlement from "./DataReactTableSettlement";
import RipsApi from "../../Rips/api/RipsApi";
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import ModalUI from '../../../shared/components/Modal';
import { formatNumber } from "../../Utils/Money";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const CHIP_MAX_WIDTH = 100;
const CHIP_ICON_WIDTH = 10;
const EllipsisText = props => {
    const { children } = props;

    return (
        <div
            style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH
            }}
        >
            {children}
        </div>
    );
};

const Settlement = () => {

    const [isMounted, setIsMounted] = useState(false);
    const [settleReport, setSettleReport] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [thirds, setThirds] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [idThird, setIdThird] = useState(null);
    const [thirdSelected, setThirdSelected] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [field, setField] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [invoice, setInvoice] = useState(0);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [selectRangeInvoices, setSelectRangeInvoices] = useState(false);
    const [contractsThird, setContractsThird] = useState([]);
    const [contract, setContract] = useState(null);
    const [dateSettlementReport, setDateSettlementReport] = useState(null);
    const [thirdPlusContrat, setThirdPlusContrat] = useState([]);
    const [invoicesFromcontracts, setInvoicesFromcontracts] = useState([]);
    const [idContract, setIdContract] = useState(null);

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        if (thirds.length <= 0) {
            listThirds();
        }
        if (thirdPlusContrat.length <= 0) {
            loadThirdPlusContract();
        }
        if (settleReport <= 0) {
            getSettlemet();
        }
        setIsMounted(true);
        console.log("SETTLE", settleReport)
        /* if (idThird != null && startDate != null && endDate != null && invoice == 0) {
            validateInvoices();
        } */
        if (idThird !== null && idContract !== null && startDate != null && endDate != null) {
            loadThirdPartyInvoicesWithContractWithoutRad();
            listPlans(idThird);
            //loadThirdPartyInvoicesWithContract();
        }
    }, [isMounted, idThird, idContract, startDate, endDate, invoice,])


    const validate = () => {
        let campo = field;
        let error = {};
        let formularioValido = true;
        if (idThird === null) {
            formularioValido = false;
            error = "Seleccione un cliente";
        }
        setErrors(error)
        return formularioValido;
    };

    const validateInvoices = async () => {
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        }
        await RipsApi.listarFacturasParaRips(dataSend).then(response => {
            setInvoices(response);
            console.log("INVOICES", response)
        }).catch(error => {
            console.log(error);
        });
    }


    const listThirds = async () => {
        await ThirdsApi.listThirdsReports().then((res) => {
            setThirds(res);
            //console.log(res);
        }).catch((err) => {
            console.log(err);
        });
    }

    //Lista los terceros con el contrato
    const loadThirdPlusContract = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/listar-terceros', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log("DATAtHIRDpLUScONTRACT", data);
                if (isMounted) {
                    setThirdPlusContrat(data)
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    //lista las facturas que hasta el momento no tienen radicación
    const loadThirdPartyInvoicesWithContractWithoutRad = async () => {
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_contrato: idContract,
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'contratos/verificar-facturas-sin-radicar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log("InvoicesWithoutRAD", data);
                if (isMounted) {
                    setInvoicesFromcontracts(data)
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    //Eliminar Radicado

    const deleteRad = async (id_rad) => {
        let dataSend = {
            id_radicado: id_rad
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'radicados/eliminar-radicado', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403 && response.status != 404) {
                    getSettlemet();
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                }
                else {
                    throw new Error(response.json());
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    //Lista las facturas del tercero según el contrato
    const loadThirdPartyInvoicesWithContract = async () => {
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_contrato: idContract,
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'contratos/verificar-facturas', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then(data => {
                console.log("InvoicesContracts", data);
                if (isMounted) {
                    setInvoicesFromcontracts(data)
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const listPlans = async (id_third) => {
        await ThirdsApi.getContracts(id_third).then((res) => {
            console.log("RESPONSE", res)
            setContractsThird(res);
        })
            .catch((error) => {
                console.log(error);
            })
        console.log("STATECONT", contractsThird)
    }

    const handleChangeThirds = (third) => {
        setThirdSelected(third);
        setInvoice(0);
        setIdThird(third.id_tercero);
        setIdContract(parseInt(third.id_contrato));
        console.log("ThirdID", third, "ContractID", idContract);
    }

    const handleChangeContractThird = (contract) => {
        setInvoice(0);
        setContract(contract)
        console.log("STATEcONTRACT", contract)
    }

    const handleChangeStartDate = async (date) => {
        setInvoice(0);
        setStartDate(date);

    }

    const handleChangeEndDate = async (date) => {
        setInvoice(0);
        setEndDate(date);
    }

    const handleChangeRangeInvoices = (_checkInvoice) => {
        setSelectRangeInvoices(_checkInvoice);
    }

    const sendSettlementReport = async () => {
        setIsLoading(true);
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let facturasSeleccionadas = [];
        console.log("ALLINVOICESFROMCONTRACT", invoicesFromcontracts)
        console.log("SELECTEDINVOICES", selectedInvoices)
        if (Object.entries(selectedInvoices).length === 0) {
            for (let i = 0; i < invoicesFromcontracts.length; i++) {
                const element = invoicesFromcontracts[i];
                facturasSeleccionadas.push(element.id_factura_t);
            }
            console.log('FacturasSelec', facturasSeleccionadas);
        } else {
            facturasSeleccionadas = selectedInvoices;
            console.log('FacturasSelecALL', facturasSeleccionadas);
        }
        let dataSend = {
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            facturas: facturasSeleccionadas,
        }
        console.log("DATASENDGENERAR", dataSend);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'radicados/generar-radicado', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    setModalAlert({
                        message: "No hay facturas para radicar en este rango de fechas o ya han sido radicadas",
                        color: 'danger',
                        title: "ERROR!"
                    });
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("radicados/generar-radicado", data)
                //getDataToPrint(data, fechaInicial, fechaFinal);
                constgetDataToExcel(data)
                getSettlemet();
                setEndDate(null);
                setStartDate(null);
                setIdThird(null);
                setSelectedInvoices([]);
                setSelectRangeInvoices(false);
                setThirdSelected(null);
                setInvoicesFromcontracts([])
            })
            .catch((error) => {
                console.log(error);
                setModalAlert({
                    message: "No hay facturas para radicar en este rango de fechas o ya han sido radicadas",
                    color: 'danger',
                    title: "ERROR!"
                });
            })
    };

    const getDataToPrint = (data, fechaInicial, fechaFinal, fechaRadicacion, contrato) => {
        setOpenModal(true);
        let paymentsDetails = calculatePaymentsDetails(data);
        console.log("DATOS", data);
        console.log("fechaRadicacion", fechaRadicacion)
        GeneratePDFReportServices(data, paymentsDetails, fechaInicial, fechaFinal, fechaRadicacion, contrato);
    }

    const constgetDataToExcel = (data) => {
        GenerateExcelReportServices.exportExcel(data)
    }

    const getSettlemet = async () => {
        setIsLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'radicados/listar-radicados', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("DATOSGET", data)
                if (isMounted) {
                    setSettleReport(data)
                    //setDateSettlementReport(fechaRad)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    };


    const calculatePaymentsDetails = (data) => {
        let details = {
            valor_servicio_item: 0,
            valor_copago_item: 0,
            valor_neto_item: 0,
            cant_fact: 0
        }
        for (let i = 0; i < data.length; i++) {
            details.valor_servicio_item = parseInt(details.valor_servicio_item) + parseInt(data[i].valor_servicio_item);
            details.valor_copago_item = parseInt(details.valor_copago_item) + parseInt(data[i].valor_copago_item);
            details.valor_neto_item = parseInt(details.valor_neto_item) + parseInt(data[i].valor_neto_item);
            details.cant_fact = i + 1;
        }
        return details;
    }

    const calculateValueItemsReport = (rad) => {

        if(rad.radicado != null && rad.radicado != undefined)
        {
            let total_receivable = 0;
            for (let i = 0; i < rad.radicado.length; i++) {
                const element = rad.radicado[i];
                total_receivable += element.valor_neto_item;
            }
            return total_receivable;
        }
        else
        {
            return 0;
        }
    }

    const reactTableDataSettlement = {
        tableHeaderData: [{
            Header: 'RAD',
            accessor: 'id_radicado',
            //disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'FECHA EMISIÓN',
            accessor: 'fecha_radicado',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        {
            Header: 'CLIENTE',
            accessor: 'nombre_tercero',
        },
        {
            Header: 'CONTRATO Y REGIMEN',
            Cell: row => (
                <label>{row.row.original.contrato !== null && row.row.original.contrato !== undefined ? row.row.original.contrato.numero_contrato + ' ' +  row.row.original.contrato.regimen_nombre : '' }</label>
            )
        },
        {
            Header: 'FACTURAS',
            accessor: 'facturas_string',
            Cell: row => (
                <div style={{width: '20em', overflowX: 'auto'}}>
                    {row.value}
                </div>
            )
        },
        {
            Header: 'VALOR A COBRAR',
            Cell: row => (
                <label>$ {formatNumber(calculateValueItemsReport(row.row.original.data))}</label>
            )
        },
        {
            Header: 'FECHA DE RADICADO',
            accessor: 'fecha_cierre',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        ],
        tableRowsData: settleReport
    };

    const LoadInfo = () => {
        return (<DataReactTableSettlement
            reactTableData={reactTableDataSettlement}
            dataToPrintPDF={getDataToPrint}
            getSettlemet={getSettlemet}
            dataToExcel={constgetDataToExcel}
            deleteRad={deleteRad} />)
    }


    return (
        <Fragment>
            <Card>
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <h5 style={{ color: '#757575' }}>
                                Seleccione el Cliente y el Rango de Fechas para generar los Soportes.
                            </h5>
                            <br />
                        </Col>
                        <Col md={3}>
                            <TextField
                                id="select_third"
                                select
                                label="Cliente + Contrato"
                                value={thirdSelected}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    handleChangeThirds(event.target.value);
                                    //listPlans(event.target.value);
                                }}
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                helperText={errors.idThird}
                            >
                                {thirdPlusContrat.map((third, index) => {
                                    return <MenuItem key={index} value={third}>
                                        {third.nombre_tercero_concatenado}
                                    </MenuItem>
                                })}
                            </TextField>
                        </Col>
                        <Col md={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <ThemeProvider theme={defaultMaterialTheme}>

                                    <DatePicker
                                        disableFuture
                                        openTo="date"
                                        label="Fecha Inicial"
                                        views={["year", "month", "date"]}
                                        value={startDate}
                                        onChange={(date) => {
                                            handleChangeStartDate(date);
                                        }}
                                        className='medical-material-form__field'
                                        animateYearScrolling
                                        format="D/MM/yyyy"
                                        autoOk={true}
                                    />
                                </ThemeProvider>
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <ThemeProvider theme={defaultMaterialTheme}>
                                    <DatePicker
                                        disableFuture
                                        openTo="date"
                                        label="Fecha Final"
                                        views={["year", "month", "date"]}
                                        value={endDate}
                                        onChange={(date) => {
                                            handleChangeEndDate(date);
                                        }}
                                        className='medical-material-form__field'
                                        animateYearScrolling
                                        format="D/MM/yyyy"
                                        autoOk={true}
                                    />
                                </ThemeProvider>
                            </MuiPickersUtilsProvider>
                        </Col>
                        {/* <Col md={3}>
                            {
                                <TextField
                                    id="select-invoice-generate"
                                    select
                                    label="Factura"
                                    value={selectedInvoices}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        setSelectedInvoices(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                >
                                    <MenuItem key={0} value={0}>
                                        Facturas del Rango de Fechas
                                    </MenuItem>
                                    {invoices.map((inv) => {
                                        return <MenuItem key={inv.id_factura_t} value={inv.id_factura_t}>
                                            {inv.num_fac_ter}
                                        </MenuItem>
                                    })}
                                </TextField>
                            }
                        </Col> */}
                        <Col md={3}>
                            <FormControlLabel
                                id={"chkxIncluyeMedicamentos_FormLabel"}
                                value={selectRangeInvoices}
                                control={
                                    <MedicalCheckbox
                                        id={"chkxRI"}
                                        checked={selectRangeInvoices}
                                        onChange={(event, check) => {
                                            console.log(check);
                                            handleChangeRangeInvoices(check);
                                        }}
                                        iconStyle={{ fill: 'green' }}
                                    />
                                }
                                label={"Seleccionar facturas específicas del rango de fechas"}
                                labelPlacement={"Incluir Medicamentos"}
                            />
                        </Col>
                        {selectRangeInvoices ?
                            <Col md={3}>
                                <FormControl className='medical-material-form__field'>
                                    <InputLabel id="demo-mutiple-checkbox-label">Facturas</InputLabel>
                                    <Select
                                        labelId="demo-mutiple-checkbox-label"
                                        id="demo-mutiple-checkbox"
                                        multiple
                                        className='medical-material-form__field'
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        value={selectedInvoices}
                                        onChange={(event) => {
                                            setSelectedInvoices(event.target.value)
                                            console.log("FACTURASSELECCIONADAS", selectedInvoices)
                                        }}
                                        input={<Input />}
                                        renderValue={(selected) => (
                                            <div>
                                                {selected.map((value, index) => (
                                                    <Chip
                                                        size="small"
                                                        label={
                                                            <EllipsisText>
                                                                {invoicesFromcontracts.find(inv => inv.id_factura_t == value) != undefined ?
                                                                    invoicesFromcontracts.find(inv => inv.id_factura_t == value).num_fac_ter : null
                                                                }
                                                            </EllipsisText>
                                                        }
                                                    />
                                                ))}
                                            </div>
                                        )
                                            //selected.join(',')
                                        }
                                    >
                                        {invoicesFromcontracts.map((invo1ce) => (

                                            <MenuItem key={invo1ce.id_factura_t} value={invo1ce.id_factura_t}>
                                                <MedicalCheckbox
                                                    style={{ marginRight: 8 }}
                                                    checked={selectedInvoices.indexOf(invo1ce.id_factura_t) > -1}
                                                />
                                                <ListItemText primary={invo1ce.num_fac_ter} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Col>
                            : null}
                    </Row>
                    <ModalTemplatePdf openModal={openModal} closeModal={() => setOpenModal(false)} />
                    <Row>

                    </Row>
                    <br />
                    <Row>
                        <Col md={12}>
                            <br />
                            <Button
                                disabled={invoicesFromcontracts !== null && invoicesFromcontracts !== undefined && invoicesFromcontracts.length ? false : true}
                                onClick={() => {
                                    sendSettlementReport();
                                }}
                                className="btn btn-primary text-white"
                            >
                                Generar
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            {
                                <LoadInfo />
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    );
};

export default Settlement;
